export const chatKey = {
  fetchMessages(groupId?: number) {
    if (groupId) return ['messages', 'list', groupId];
    else return ['messages', 'list'];
  },
  fetchNewMessages(groupId) {
    return ['new', 'messages', 'list', groupId];
  },
  fetchHasUnreadMessage(venueId?: number) {
    if (venueId) return ['has', 'unread', 'message', venueId];
    return ['has', 'unread', 'message'];
  },
  fetchGroups(venueId) {
    return ['groups', 'list', venueId];
  },
  fetchMultiChannelGroups(venueIds) {
    if (venueIds) return ['multichannel', 'groups', 'list', venueIds];
    else return ['multichannel', 'groups', 'list'];
  },
  fetchGroupUpdates(venueIds?: string) {
    return ['groups', 'updates', venueIds];
  },
};
